import { Icon } from '@components/generic/Icon';
import React from 'react';

import { Container } from './styles';

export const Notifications: React.FC = () => {
  const numberNotify = null;
  return (
    <Container>
      {numberNotify && <p className="p3">{numberNotify}</p>}
        <Icon name="bell" color="textWhite" />
    </Container>
  );
};